import styles from './index.module.css';

import Button from 'components/core/button';

import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { ROUTES } from 'routes';
import { Link } from 'react-router-dom';

import { useSimplexPageStore } from 'modules/simplex/provider/SimplexPageStoreProvider';

import { ReactComponent as CheckSvg } from 'assets/images/check.svg';
import { ReactComponent as CrossSvg } from 'assets/images/cross.svg';

const TransactionResult = ({
  success,
  text,
  showExchangeMore,
}: {
  success: boolean;
  text: string;
  showExchangeMore?: boolean;
}) => {
  const intl = useIntl();
  const simplexPageStore = useSimplexPageStore();

  const onExchangeMore = useCallback(() => {
    simplexPageStore.init();
  }, [simplexPageStore]);

  return (
    <div className={styles.main}>
      {success ? <CheckSvg /> : <CrossSvg />}

      <span>{text}</span>

      <div className={styles.actions}>
        {showExchangeMore && (
          <Button variant='primary' onClick={onExchangeMore}>
            {intl.formatMessage({
              id: 'simplex_page.exchange_more',
              defaultMessage: 'Exchange more',
            })}
          </Button>
        )}

        <Link to={ROUTES.index.card.fullPath}>
          <Button variant='secondary'>
            {intl.formatMessage({
              id: 'simplex_page.back',
              defaultMessage: 'Back',
            })}
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default TransactionResult;
